module.exports = {"types":["Light","Medium","Heavy"],"values":[{"name":"Padded","type":"Light"},{"name":"Leather","type":"Light"},{"name":"Studded leather","type":"Light"},{"name":"Hide","type":"Medium"},{"name":"Chain shirt","type":"Medium"},{"name":"Scale mail","type":"Medium"},{"name":"Breastplate","type":"Medium"},{"name":"Half plate","type":"Medium"},{"name":"Ring mail","type":"Heavy"},{"name":"Chain mail","type":"Heavy"},{"name":"Splint","type":"Heavy"},{"name":"Plate","type":"Heavy"}]}


//////////////////
// WEBPACK FOOTER
// ./src/item-helpers/Armors.json
// module id = 551
// module chunks = 0